import AuthService from '@/services/AuthService';

const initialState = { user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error);
        },
      );
    },
    getUserLanguage() {
      return AuthService.getUserLanguage().then(
        (language) => {
          return Promise.resolve(language);
        },
        (error) => {
          return Promise.reject(error);
        },
      );
    },

    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },

    refreshToken({ commit }) {
      return AuthService.refreshToken().then(() => commit('refreshSuccess'));
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.user = user;
    },
    loginFailure(state) {
      state.user = null;
    },
    logout(state) {
      state.user = null;
    },
    refreshSuccess(state, token) {
      if (state.user !== null) {
        state.user.token = token;
      }
    },
  },
};
